export const getRgbString = ([r, g, b]) => `rgb(${r},${g},${b})`;

/*
использую (16777216 + r * 65536 + g * 256 + b)
вместо ((1 << 24) + (r << 16) + (g << 8) + b)
*/
export const getHexString = ([r, g, b]) =>
  `#${(16777216 + r * 65536 + g * 256 + b).toString(16).slice(1)}`;

export const getContrastRgb = ([r, g, b]) => {
  const contrast = Math.round((r * 299 + g * 587 + b * 114) / 1000);
  return contrast >= 125 ? [0, 0, 0] : [255, 255, 255];
};

export const getRandomRgb = () => [
  Math.floor(Math.random() * 256),
  Math.floor(Math.random() * 256),
  Math.floor(Math.random() * 256),
];

export const getContrastRgbString = (color) => {
  const contrastRGB = getContrastRgb(color);
  return getRgbString(contrastRGB);
};
